import React from "react";
import { NOTIFICATION_STATUS } from "App/componentsConfig";
import { ReactComponent as CloseIcon } from "assets/images/app_svg/close.svg";

function notify(props) {
  const notification = props.refresh.show
    ? "warning"
    : props.notify.params.status;
  return (
    <div
      className={[
        "notification_wrap header_message",
        props.topFix ? "topFix" : "",
        props?.notify?.params?.bottomFix ? "bottomFix" : "",
        props?.notify?.params?.customClass || ""
      ].join(" ")}
      style={{ display: "flex" }}
    >
      <div
        className={[
          "msg_wrap",
          props.commonNotify ? "common_notify" : "",
          NOTIFICATION_STATUS[notification].class
        ].join(" ")}
      >
        <div
          className={[
            "msg_wrap_inner",
            props.noImage ? "" : NOTIFICATION_STATUS[notification].wrapClass
          ].join(" ")}
        >
          {props.svg &&
            React.createElement(NOTIFICATION_STATUS[notification].svg)}

          <p className="msg_wrap_test">
            {props.notify.params && props.notify.params.msg}
            {props.refresh.show && (
              <React.Fragment>
                Settings were changed in a different session, please click on
                refresh
                <span
                  className="refresh_btn"
                  title="Refresh"
                  onClick={props.refresh.fetch}
                >
                  Refresh
                </span>
              </React.Fragment>
            )}
            {/* {props.notify.params && props.notify.params.upgrade && (
              <span
                className="upgrade_btn"
                title="Upgrade now"
                // onClick={props.refresh.fetch}
              >
                Upgrade Now
              </span>
            )} */}
          </p>
        </div>
        {!props.refresh.show &&
          props.notify.params &&
          !props.notify.params.upgrade && (
            <div className="msg_wrap_close" onClick={props.closeNotify}>
              <a className="close_info">
                <CloseIcon />
              </a>
            </div>
          )}
      </div>
    </div>
  );
}

export default notify;
